// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        emergentLink: 'home-emergent-link',
};

export const WEDDING = {
        muteButton: 'mute-bgm-button',
        openInvitation: 'invitation-open',
        navRsvp: 'nav-rsvp-link',
        heroScrollCue: 'hero-scroll-cue',
        mapLinkWedding: 'wedding-map-link',
        mapLinkReception: 'reception-map-link',
        googleSignin: 'rsvp-google-signin',
        acceptToggle: 'rsvp-accept-toggle',
        eventMarriage: 'rsvp-event-marriage',
        eventReception: 'rsvp-event-reception',
        seatDecrement: 'rsvp-seat-decrement',
        seatIncrement: 'rsvp-seat-increment',
        seatCount: 'rsvp-seat-count',
        rsvpSubmit: 'rsvp-submit',
        rsvpRemove: 'rsvp-remove-seat',
        exportCsv: 'admin-export-csv',
        guestRow: 'admin-guest-row',
};
